"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleStore = void 0;
class RoleStore {
    data;
    constructor() {
        this.data = {};
    }
    query(options) {
        return Object.values(this.data).filter(r => {
            if (options?.filterMainRole && r.isMainRole() != options.isMainRole) {
                return false;
            }
            if (options?.excludeOrRole && r.isOrRole() === options.isOrRole) {
                return false;
            }
            if (options?.filterRoleSection && r.isRoleSection != options.isRoleSection) {
                return false;
            }
            if (options?.joinedEmployee != undefined) {
                const joinedEmployee = options.joinedEmployee;
                if (!(r.getJoinedEmployees().includes(joinedEmployee))) {
                    return false;
                }
            }
            return true;
        });
    }
    add(r) {
        this.data[r.getId()] = r;
    }
    byId(id) {
        return this.data[id];
    }
    delete(id) {
        if (!this.data[id]) {
            return;
        }
        delete this.data[id];
    }
    resetData() {
        this.data = {};
    }
}
exports.RoleStore = RoleStore;
